import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@instructure/ui-spinner';
import { Flex } from '@instructure/ui-flex';
import t from 'format-message';
import { launchContextsShape } from "../../store/shapes.js";
var OutcomePickerLoader = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomePickerLoader, _React$Component);
  var _super = _createSuper(OutcomePickerLoader);
  function OutcomePickerLoader() {
    _classCallCheck(this, OutcomePickerLoader);
    return _super.apply(this, arguments);
  }
  _createClass(OutcomePickerLoader, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var loadOutcomePicker = this.props.loadOutcomePicker;
      loadOutcomePicker();
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.props.outcomePickerState) {
        case 'loading':
          return /*#__PURE__*/React.createElement(Flex, {
            justifyItems: "center"
          }, /*#__PURE__*/React.createElement(Flex.Item, {
            padding: "small"
          }, /*#__PURE__*/React.createElement(Spinner, {
            renderTitle: t('Loading')
          })));
        case 'choosing':
          {
            var OutcomePicker = this.props.outcomePicker;
            return /*#__PURE__*/React.createElement(OutcomePicker, {
              scope: this.props.scope,
              launchContexts: this.props.launchContexts,
              artifactTypeName: this.props.artifactTypeName,
              displayMasteryDescription: this.props.displayMasteryDescription,
              displayMasteryPercentText: this.props.displayMasteryPercentText,
              setFocusedOutcome: this.props.setFocusedOutcome,
              screenreaderNotification: this.props.screenreaderNotification
            });
          }
        case 'saving':
          return /*#__PURE__*/React.createElement(Flex, {
            justifyItems: "center"
          }, /*#__PURE__*/React.createElement(Flex.Item, {
            padding: "small"
          }, /*#__PURE__*/React.createElement(Spinner, {
            renderTitle: t('Saving')
          })));
        case 'complete':
          return /*#__PURE__*/React.createElement("div", null, t('Complete'));
        case 'closed':
        default:
          return /*#__PURE__*/React.createElement("div", null);
      }
    }
  }]);
  OutcomePickerLoader.displayName = "OutcomePickerLoader";
  return OutcomePickerLoader;
}(React.Component);
OutcomePickerLoader.propTypes = {
  loadOutcomePicker: PropTypes.func.isRequired,
  setFocusedOutcome: PropTypes.func.isRequired,
  outcomePickerState: PropTypes.string.isRequired,
  outcomePicker: PropTypes.func.isRequired,
  scope: PropTypes.string.isRequired,
  launchContexts: launchContextsShape,
  artifactTypeName: PropTypes.string,
  displayMasteryDescription: PropTypes.bool,
  displayMasteryPercentText: PropTypes.bool,
  screenreaderNotification: PropTypes.func
};
OutcomePickerLoader.defaultProps = {
  launchContexts: null,
  artifactTypeName: null,
  displayMasteryDescription: false,
  displayMasteryPercentText: false,
  screenreaderNotification: null
};
export { OutcomePickerLoader as default };